import { getAssignedAmount } from '@/redux/ducks/banking/_helpers/getAssignedAmount'
import { getBookingAmount } from '@/modules/banking/components/booking-assignments/_helper/getBookingAmount'
import { bookingAssignmentsSelectionFilterTypes } from '@/modules/banking/config'

const initialState = {
  open: false,
  openDetail: false,
  selectedBooking: null,
  masterType: null,
  detailType: null,
  transferType: null,
  activeTransactionType: 'all',
  selectedTransactions: [],
  selectedProceeding: null,
  searchTerm: '',
  assignedAmount: 0,
  createAssignmentsArePossible: false,
  filter: {
    state: null,
    divergent: false,
  },
  refresh: false,
  isLoading: false,
  formIsValidForGWG: true,
}

const ACTION_PREFIX = 'banking/bookingAssignments'
const OPEN_DRAWER = `${ACTION_PREFIX}/openDrawer`
const OPEN_DETAIL_DRAWER = `${ACTION_PREFIX}/openDetailDrawer`
const CLOSE_DRAWER = `${ACTION_PREFIX}/closeDrawer`
const CLOSE_DETAIL_DRAWER = `${ACTION_PREFIX}/closeDetailDrawer`
const SELECT_BOOKING = `${ACTION_PREFIX}/selectBooking`
const SET_ACTIVE_TRANSACTION_TYPE = `${ACTION_PREFIX}/setActiveTransactionType`
const SET_TRANSACTION_SEARCH_TERM = `${ACTION_PREFIX}/setTransactionSearchTerm`
const REFRESH_LIST = `${ACTION_PREFIX}/refreshList`
const STOP_REFRESHING_LIST = `${ACTION_PREFIX}/stopRefreshingList`
const SHOW_LOADER = `${ACTION_PREFIX}/showLoader`
const HIDE_LOADER = `${ACTION_PREFIX}/hideLoader`
const SET_ACTIVE_FILTER = `${ACTION_PREFIX}/setActiveFilter`
const SET_SELECTED_TRANSACTIONS = `${ACTION_PREFIX}/setSelectedTransactions`
const SET_SELECTED_PROCEEDING = `${ACTION_PREFIX}/setSelectedProceeding`
const SET_CREATE_ASSIGNMENTS_ARE_POSSIBLE = `${ACTION_PREFIX}/createAssignmentsArePossible`
const RESET_STATE = `${ACTION_PREFIX}/resetState`
const SET_FORM_VALIDATION_FOR_GWG = `${ACTION_PREFIX}/SET_FORM_VALIDATION_FOR_GWG`

export default function bookingAssignmentsReducer(state = initialState, action) {
  switch (action.type) {
    case OPEN_DRAWER: {
      const { options: { masterType, detailType, transferType } } = action
      return { ...state, open: true, openDetail: false, masterType, detailType, transferType }
    }
    case OPEN_DETAIL_DRAWER: {
      let types = {}
      if (action && action.options) {
        const { options: { masterType, detailType, transferType } } = action
        types = { masterType, detailType, transferType }
      }
      return { ...state, open: true, openDetail: true, ...types }
    }
    case CLOSE_DRAWER: {
      return { ...state, open: false }
    }
    case CLOSE_DETAIL_DRAWER: {
      return { ...state, openDetail: false }
    }
    case SELECT_BOOKING: {
      const { booking } = action
      const { amount, categorization: { assignments } } = booking
      booking.amountMinusAssignments = getBookingAmount(amount, assignments)
      return { ...state, selectedBooking: booking }
    }
    case SET_ACTIVE_TRANSACTION_TYPE: {
      const { transactionType } = action
      return {
        ...state,
        activeTransactionType: transactionType,
      }
    }
    case SET_TRANSACTION_SEARCH_TERM: {
      const { searchTerm } = action
      return {
        ...state,
        searchTerm,
      }
    }
    case REFRESH_LIST: {
      return { ...state, refresh: true }
    }
    case STOP_REFRESHING_LIST: {
      return { ...state, refresh: false }
    }
    case SHOW_LOADER: {
      return { ...state, isLoading: true }
    }
    case HIDE_LOADER: {
      return { ...state, isLoading: false }
    }
    case SET_ACTIVE_FILTER: {
      const { filter } = action
      return {
        ...state,
        filter: { ...state.filter, ...filter },
      }
    }
    case SET_SELECTED_TRANSACTIONS: {
      const { transactions } = action
      const assignedAmount = getAssignedAmount(transactions)
      return {
        ...state,
        selectedTransactions: transactions,
        assignedAmount,
      }
    }
    case SET_CREATE_ASSIGNMENTS_ARE_POSSIBLE: {
      const { isPossible } = action
      return {
        ...state,
        createAssignmentsArePossible: isPossible,
      }
    }
    case SET_SELECTED_PROCEEDING: {
      const { name } = action
      return { ...state, selectedProceeding: name }
    }
    case RESET_STATE: {
      return initialState
    }
    case SET_FORM_VALIDATION_FOR_GWG: {
      return {
        ...state,
        formIsValidForGWG: action.payload,
      }
    }
    default: {
      return { ...state }
    }
  }
}

export const openBookingAssignmentsDrawer = (options) => ({ type: OPEN_DRAWER, options })
export const closeBookingAssignmentsDrawer = () => ({ type: CLOSE_DRAWER })
export const openBookingAssignmentsDetailDrawer = (options) => ({ type: OPEN_DETAIL_DRAWER, options })
export const closeBookingAssignmentsDetailDrawer = () => ({ type: CLOSE_DETAIL_DRAWER })
export const selectBooking = (booking) => ({ type: SELECT_BOOKING, booking })
export const setActiveTransactionType = (transactionType) => ({ type: SET_ACTIVE_TRANSACTION_TYPE, transactionType })
export const setTransactionSearchTerm = (searchTerm) => ({ type: SET_TRANSACTION_SEARCH_TERM, searchTerm })
export const refreshList = () => ({ type: REFRESH_LIST })
export const stopRefreshingList = () => ({ type: STOP_REFRESHING_LIST })
export const showLoader = () => ({ type: SHOW_LOADER })
export const hideLoader = () => ({ type: HIDE_LOADER })
export const setActiveFilter = (filter) => ({ type: SET_ACTIVE_FILTER, filter })
export const setFormValidationForGWG = (isValid) => ({ type: SET_FORM_VALIDATION_FOR_GWG, payload: isValid })
export const setSelectedTransactions = (transactions) => {
  return (dispatch, getState) => {
    dispatch({ type: SET_SELECTED_TRANSACTIONS, transactions })

    const {
      banking: {
        bookingAssignments: { activeTransactionType, selectedTransactions, assignedAmount },
        bookingAssistant: { selectedBooking },
      },
    } = getState()

    const assignmentsArePossible = (() => {
      if (selectedTransactions.length === 0 || !selectedBooking) {
        return false
      }
      if (activeTransactionType === bookingAssignmentsSelectionFilterTypes.ALL) {
        return (selectedBooking.amountMinusAssignments >= 0)
          ? assignedAmount > 0
          : assignedAmount < 0
      }

      return true
    })()

    dispatch({ type: SET_CREATE_ASSIGNMENTS_ARE_POSSIBLE, isPossible: assignmentsArePossible })
  }
}
export const setSelectedProceeding = (name) => ({ type: SET_SELECTED_PROCEEDING, name })
export const resetState = () => ({ type: RESET_STATE })
